// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
require("angular");

var app = angular.module("tripay-table", []);

var controller = function($scope, $filter) {

  var limit = 15;
  $scope.page = 1;
  $scope.pageCount = 0;

  $scope.search = "";

  window.tripayData.forEach(r => r.ratio = typeof r.additional == "string" ? "-" : r.additional / (r.base + r.additional) * 100);

  $scope.getFrame = function() {
    var query = new RegExp($scope.search, "i");
    var filtered = $scope.search ? window.tripayData.filter(n => n.district.match(query)) : window.tripayData;
    var offset = ($scope.page - 1) * limit;
    var page = filtered.slice(offset, offset + limit);
    $scope.pageCount = Math.ceil(filtered.length / limit);
    return page;
  }

  $scope.$watch("search", function() {
    $scope.page = 1;
    $scope.getFrame();
  });

  $scope.shiftOffset = function(shift) {
    var now = $scope.page + shift;
    if (now < 1) now = 1;
    if (now >= $scope.pageCount) now = $scope.pageCount;
    $scope.page = now;
    $scope.getFrame();
  };

  var column = null;
  var desc = false;

  $scope.sortOn = function(on) {
    desc = on == column ? !desc : false;
    column = on;
    window.tripayData.sort(function(a, b) {
      a = a[on];
      b = b[on];
      if (a == b) return 0;
      var comp = a < b ? -1 : 1;
      if (desc) comp *= -1;
      return comp;
    });
  }

};
controller.$inject = ["$scope", "$filter"];

app.controller("tripay", controller);

app.filter("na", ["$filter", function($filter) {
  var numeric = $filter("number");

  return function(input, digits, prefix = "", suffix = "") {
    if (typeof input == "string") return input;
    return prefix + numeric(input, digits) + suffix;
  };
}]);